import * as e from "react";
import { forwardRef as t } from "react";
const l = t(function(r, o) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: o,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11 8L15 12L11 16",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      }
    )
  );
});
export {
  l as ChevronSmallRight
};
